import React, { createContext, useContext } from 'react';

export const AppContext = createContext({
  sidePanelView: {},
  setSidePanelView: () => {},
});

export const AppProvider = props => {
  const { children, state } = props;
  return <AppContext.Provider value={state}>{children}</AppContext.Provider>;
};

export function useAppContext() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within a AppProvider');
  }
  return context;
}
